const AUTH_SESSION_KEY = "takofy_has_session_hint";
const AUTH_USER_KEY = "takofy_auth_user_snapshot";

export function setAuthSessionHint() {
  localStorage.setItem(AUTH_SESSION_KEY, "1");
}

export function clearAuthSessionHint() {
  localStorage.removeItem(AUTH_SESSION_KEY);
}

export function hasAuthSessionHint() {
  return localStorage.getItem(AUTH_SESSION_KEY) === "1";
}

export function setAuthUserSnapshot(user) {
  if (!user) return;
  localStorage.setItem(AUTH_USER_KEY, JSON.stringify(user));
}

export function getAuthUserSnapshot() {
  try {
    const raw = localStorage.getItem(AUTH_USER_KEY);
    return raw ? JSON.parse(raw) : null;
  } catch {
    return null;
  }
}

export function clearAuthUserSnapshot() {
  localStorage.removeItem(AUTH_USER_KEY);
}
